import { render, staticRenderFns } from "./StaysInfo.vue?vue&type=template&id=36dd07ad&scoped=true&"
import script from "./StaysInfo.vue?vue&type=script&lang=ts&"
export * from "./StaysInfo.vue?vue&type=script&lang=ts&"
import style0 from "./StaysInfo.vue?vue&type=style&index=0&id=36dd07ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dd07ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36dd07ad')) {
      api.createRecord('36dd07ad', component.options)
    } else {
      api.reload('36dd07ad', component.options)
    }
    module.hot.accept("./StaysInfo.vue?vue&type=template&id=36dd07ad&scoped=true&", function () {
      api.rerender('36dd07ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-viz/StaysInfo.vue"
export default component.exports